<template>
  <div>
    <MotivoReagendamentoModal
      :item="item"
      :atualizar-motivo-reagendamento="(it) => atualizarMotivoReagendamento(it)"
    />

    <div class="col-12 px-0">
      <div class="d-flex align-items-center justify-content-between mb-0">
        <div>
          <h5 class="font-weight-bold">
            Motivos de Reagendamento (Agenda Ativa)
          </h5>
        </div>

        <div>
          <div class="input-group mb-3">
            <b-input
              :placeholder="$t('Type to search')"
              class="form-control search-input"
              type="search"
              v-model="search"
              aria-describedby="input-search"
              v-on:change="getMotivosReagendamentos"
            />
            <div class="input-group-append" role="button">
							<span class="input-group-text" id="input-search">
                <i class="fas fa-search search-icon"/>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="inserirMotivoReagendamento">
      <div class="row">
        <form-input
          :required="true"
          v-model="nome"
          label="Nome"
          grid="4"
        />
        <form-input
          v-model="descricao"
          label="Descrição"
          grid="6"
        />
        <div class="col-md-2 pl-0">
          <button
            class="btn btn-block btn-submit-motivos-reagendamento btn-success btn-sm mt-4"
            data-style="zoom-in"
            type="submit"
          >
            {{ $t("Cadastrar") }}
            <i class="mdi mdi-content-save"/>
          </button>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <b-table
          :fields="[
						{
							key: 'id',
							label: $t('ID'),
							thStyle: { width: '50px', minWidth: '50px' },
						},
						{
							key: 'nome',
							label: $t('Nome'),
						},
						{
							key: 'descricao',
							label: $t('Descrição'),
						},
						{
							key: 'habilitado',
							label: $t('Ativo'),
						},
						{
							key: 'actions',
							label: '',
							class: 'text-right',
							thStyle: { width: '95px', minWidth: '95px' },
						},
					]"
          :items="motivosReagendamentos"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(nome)="data">
            {{ data.item.nome }}
          </template>
          <template v-slot:cell(descricao)="data">
            {{ data.item.descricao }}
          </template>
          <template v-slot:cell(habilitado)="data">
            <strong :style="`color: ${data.item.habilitado ? '#28a745' : '#dc3545'}`">
              {{ data.item.habilitado ? "Sim" : "Não" }}
            </strong>
          </template>
          <template v-slot:cell()="data">
            <b-button
              :title="$t('Editar')"
              class="px-2 mb-0"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="success"
              @click="
                $bvModal.show('motivo-reagendamento-edit-modal');
                item = { ...data.item }
              "
            >
              <i class="mdi mdi-square-edit-outline" />
            </b-button>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                @change="getMotivosReagendamentos"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }} {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import MotivoReagendamentoModal from "./modals/MotivoReagendamentoModal.vue";

export default {
  name: "MotivoReagendamento",
  components: {
    MotivoReagendamentoModal
  },
  data() {
    return {
      motivosReagendamentos: [],
      descricao: null,
      nome: null,
      page: 1,
      search: "",
      perPage: 10,
      loading: false,
      item: "",
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {
    this.getMotivosReagendamentos();
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getMotivosReagendamentos();
      }
    },

    getMotivosReagendamentos() {
      this.loading = true;
      axios
        .get(`api/dashboard/motivos?page=${this.page}&perPage=${this.perPage}&search=${this.search}`)
        .then((response) => {
          this.motivosReagendamentos = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getMotivosReagendamentos();
          } else {
            this.loading = false;
          }
        });
    },

    async inserirMotivoReagendamento() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-motivos-reagendamento"));
      ladda.start();
      this.loading = true;
      await axios
        .post("api/dashboard/motivos", {
          descricao: this.descricao,
          nome: this.nome,
        })
        .then((response) => {
          if (response.status === 201) {
            this.getMotivosReagendamentos();
            this.$snack.success({
              button: false,
              text: "Motivo de Reagendamento cadastrado com sucesso!",
            });
            this.descricao = null;
            this.nome = null;
          }
        });
      this.loading = false;
      ladda.stop();
    },

    async atualizarMotivoReagendamento(it) {
      let ladda = Ladda.create(document.querySelector(".btn-submit-edit-motivo-reagendamento"));
      ladda.start();
      this.loading = true;
      await axios
        .put(`api/dashboard/motivos/${it.id}`, {
          descricao: it.descricao,
          nome: it.nome,
        })
        .then((response) => {
          if (response.status === 200) {
            this.getMotivosReagendamentos();
            this.$snack.success({
              button: false,
              text: "Motivo de Reagendamento atualizado com sucesso!",
            });

            this.$bvModal.hide("motivo-reagendamento-edit-modal");
          }
        });
      this.loading = false;
      ladda.stop();
    },
  },
};
</script>
